import { useEffect, useState } from "react";
import { SendPatientData } from "./FetchData";
import { toast, ToastContainer } from "react-toastify";

const InfoList = ["name", "citizen_id", "patient_id", "gender", "birthday", "phone", "disease", "other"];
const InfoText = {"patient_id": "病例號", "citizen_id":"身分證字號", "name":"名稱", "gender":"性別", "birthday":"生日", "disease":"其他疾病", "other":"備註", "phone":"電話號碼"};

function AddPatientData({patientData = {}}){
    const [patientInfo, setPatientInfo] = useState({});

    const updateInfo = (target, value) => {
        if(value==='') value=null;
        let updateList = patientData.updateList ? patientData.updateList : [];
        if(value !== patientData[target]){
            if(!updateList.includes(target))updateList.push(target);
        }
        else{
            if(updateList.includes(target))updateList.splice(updateList.indexOf(target), 1);
        }
        setPatientInfo(prevState => (
            {
                ...prevState,
                [target]: value,
                updateList: updateList
            }
        ))
    }

    const recoverInfo = () => {
        setPatientInfo(patientData)
    }

    const UseSendPatientData = (patientInfo, record_id) => {
        SendPatientData(patientInfo, record_id)
        .then((response) => {
            if(response.success){
                toast.success("成功");
            }
            else{
                if(response.message)toast.error("上傳失敗："+response.message);
            }
        })
        .catch((error) => {
            console.log("error", error);
        })
    }

    useEffect(() => {
        setPatientInfo(JSON.parse(JSON.stringify(patientData)));
    }, [])

    return(
        <div className="text-2xl flex flex-wrap justify-center">
            <ToastContainer 
                position="top-left"
                autoClose={2000}
            ></ToastContainer>
            <div>
                <table className="w-full">
                    {
                        InfoList.map((item) => (
                            <tr className="w-1/2">
                                <td className="py-2 font-bold">{InfoText[item]}</td>
                                {item!=="gender" ? 
                                (<td className="py-2 px-4 "><input className=" w-full border rounded-md px-2" type={item==="birthday" ? "date" : "text"} value={patientInfo[item] ? patientInfo[item] : ''} onChange={(event) => updateInfo(item, event.target.value)}></input></td>)
                                : (
                                    <td className="py-2 px-4 ">
                                    <select name="gender" className=" w-full border rounded-md px-2 bg-[#fff]" value={patientInfo.gender ? patientInfo.gender : ''} onChange={(event) => updateInfo(item, event.target.value)} >
                                        <option value={""}></option>
                                        <option value={"男"}>男</option>
                                        <option value={"女"}>女</option>
                                        <option value={"其他"}>其他</option>
                                    </select>
                                </td>
                                )}
                            </tr>
                        ))
                    }
                </table>
                <div className="w-full flex justify-end mt-10 ml-20">
                    <button className="ml-1 pt-2 pb-2 pl-6 pr-6 bg-[#2a4cf4] text-[#fff] rounded-lg" onClick={(event) => UseSendPatientData(patientInfo, patientInfo.record_id)}>上傳</button>  
                    { Object.entries(patientData).length > 0 ? <button className=" ml-1 py-1 px-2 bg-[#d22be1] text-[#fff]" style={{borderRadius:".5em"}} onClick={() => recoverInfo()}>還原</button> : <></>}
                </div>
            </div>
        </div>
    )
}

export default AddPatientData